<template>
  <v-card class="mx-auto" max-width="400">
    <v-card-title>Countdown Timer</v-card-title>
    <v-card-subtitle v-if="timeRemaining > 0">{{ timeRemaining }} seconds remaining</v-card-subtitle>
    <v-card-subtitle v-else>Time's up! Restarting...</v-card-subtitle>
    <v-card-subtitle>Send Count: {{ restartCount }}</v-card-subtitle>
    <v-card-actions>
      <v-btn @click="startCountdown" :disabled="isRunning || restartCount >= maxRestarts">Start</v-btn>
      <v-btn @click="stopCountdown" :disabled="!isRunning">Stop</v-btn>
    </v-card-actions>
    <v-text-field
      v-model="maxRestarts"
      label="Max Sends"
      type="number"
      min="1"
    ></v-text-field>
  </v-card>
</template>

<script>
export default {
  name: 'CountdownTimer',
  props: {
    seconds: {
      type: Number,
      required: true,
    },
    onCountdownFinish: {
      type: Function,
      default: null,
    },
  },
  data() {
    return {
      timeRemaining: this.seconds,
      intervalId: null,
      restartTimeout: null,
      isRunning: false,
      maxRestarts: 0,
      restartCount: 0,
    };
  },
  methods: {
    startCountdown() {
      this.isRunning = true;
      this.timeRemaining = this.seconds + Math.floor(Math.random() * 30) + 1;
      this.intervalId = setInterval(() => {
        if (this.timeRemaining > 0) {
          this.timeRemaining -= 1;
        } else {
          this.handleCountdownFinish();
        }
      }, 1000);
    },
    stopCountdown() {
      clearInterval(this.intervalId);
      clearTimeout(this.restartTimeout);
      this.isRunning = false;
      this.restartCount = 0;
    },
    handleCountdownFinish() {
      clearInterval(this.intervalId);

      if (this.onCountdownFinish) {
        this.onCountdownFinish();
      }

      if (this.isRunning && this.restartCount < this.maxRestarts) {
        this.restartCount += 1;
        this.restartTimeout = setTimeout(() => {
          this.startCountdown();
        }, 1000);
      } else {
        this.isRunning = false;
      }
    },
  },
  beforeUnmount() {
    clearInterval(this.intervalId);
    clearTimeout(this.restartTimeout);
  },
};
</script>

<style scoped>
.v-card {
  text-align: center;
}
</style>
